import { useEffect } from "react";
import { NOTIFY_UPLOAD_CUSTOM_EVENT_NAME } from "./useUploadNotifier";

const useUploadListener = (callback: () => void) => {
  useEffect(() => {
    const eventListener = (event: CustomEvent) => {
      if (event && event.type === NOTIFY_UPLOAD_CUSTOM_EVENT_NAME) {
        callback();
      }
    };

    window.addEventListener(NOTIFY_UPLOAD_CUSTOM_EVENT_NAME, eventListener);

    return () => {
      window.removeEventListener(
        NOTIFY_UPLOAD_CUSTOM_EVENT_NAME,
        eventListener
      );
    };
  }, [callback]);
};

export default useUploadListener;
